import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";

import Home from "./pages/Home";
import Projects from "./pages/Projects";
import ProjectDetails from "./pages/projects/ProjectDetails";
import Services from "./pages/Services";
import BrandIdentity from "./pages/services/BrandIdentity";
import UIUXDesign from "./pages/services/UIUXDesign";
import WebAppDevelopment from "./pages/services/WebAppDevelopment";
import Aibusiness from "./pages/services/AIBusiness";
import Animation from "./pages/services/Animation";
import UXStrategy from "./pages/services/UXStrategy";
import NoPage from "./pages/NoPage";
import Privacy from "./pages/Privacy";
import AnalyticsConsent from "./components/AnalyticsConsent";
import PublicLayout from "./components/public/PublicLayout";
import reportWebVitals from "./reportWebVitals";

import "./style/modern-normalize.css";
import "./style/index.css";
import "./style/style.css";
import "./style/utils.css";

export function AppRoutes() {
    return (
        <>
            <Routes>
                {/* Preserve old shared links without keeping the temporary
                    waitlist as a public destination. */}
                <Route path="waitlist" element={<Navigate to="/" replace />} />
                <Route element={<PublicLayout />}>
                    <Route index element={<Home />} />
                    <Route path="projectpage" element={<Projects />} />
                    <Route path="projects" element={<Navigate to="/projectpage" replace />} />
                    <Route path="projects/:id" element={<ProjectDetails />} />

                    <Route path="services" element={<Services />} />
                    <Route path="services/brand-identity" element={<BrandIdentity />} />
                    <Route path="services/ui-ux-design" element={<UIUXDesign />} />
                    <Route path="services/web-app-development" element={<WebAppDevelopment />} />
                    <Route path="services/animation" element={<Animation />} />
                    <Route path="services/ux-strategy" element={<UXStrategy />} />
                    <Route path="services/ai-business" element={<Aibusiness />} />
                    <Route path="privacy" element={<Privacy />} />
                    <Route path="*" element={<NoPage />} />
                </Route>
            </Routes>
            <AnalyticsConsent />
        </>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    );
}

const rootElement = document.getElementById("root");
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
